import { render, staticRenderFns } from "./CalculatePriceBlockFree.vue?vue&type=template&id=ccf7d576&scoped=true&"
import script from "./CalculatePriceBlockFree.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceBlockFree.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePriceBlockFree.vue?vue&type=style&index=0&id=ccf7d576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf7d576",
  null
  
)

export default component.exports